import api from "../axiosIntercepture";

export const postReviewRevision = async (userData) => {
    try {
        const response = await api.post("/tenant/revision/review",{userData});
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const approveTenant = async (data) => {    
    try {
        const response = await api.post(`/tenant/approve`,data);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}